import Footer from "../../component/Footer/Footer";
import { Navbar } from "../../component/Navbar/NavBar";
import { SponsorsContent } from "./Sponsors.content";

export const SponsorsPage = () => {
  return (
    <div className="d-flex flex-column vh-100">
      <Navbar fixedTop={false} />
      <SponsorsContent />
      <Footer />
    </div>
  );
};